import React, { useEffect } from 'react';

export default function Toast({ msg, type='ok', onDone }) {
  useEffect(() => {
    if (!msg) return;
    const t = setTimeout(onDone, type==='error' ? 6000 : 2800);
    return () => clearTimeout(t);
  }, [msg, type, onDone]);

  return (
    <div onClick={type==='error' ? onDone : undefined} style={{
      position:'fixed', bottom:90, left:'50%',
      transform:`translateX(-50%) translateY(${msg?0:80}px)`,
      background: type==='error' ? 'var(--red)' : 'var(--navy)',
      color:'#fff', padding:'10px 22px', borderRadius:999,
      fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:13, fontWeight:600,
      zIndex:500, transition:'transform .25s', boxShadow:'var(--sh-lg)',
      pointerEvents: type==='error' ? 'auto' : 'none',
      cursor: type==='error' ? 'pointer' : 'default',
      maxWidth:'calc(100vw - 40px)', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis',
    }}>
      {type==='error' ? '⚠ ' : ''}{msg}
    </div>
  );
}
